import axios from 'axios';
import AuthService from '../../services/AuthService';

export default {
  namespaced: true,
  state: {
    accessToken: localStorage.getItem('accessToken'),
    refreshToken: localStorage.getItem('refreshToken'),
    user: null,
    currentIdentity: null,
  },
  getters: {
    user: (state) => state.user,
    check: (state) => state.accessToken !== null && state.refreshToken !== null,
    accessToken: (state) => state.accessToken,
  },
  mutations: {
    setTokens(state, { accessToken, refreshToken }) {
      localStorage.setItem('accessToken', accessToken);
      state.accessToken = accessToken;

      localStorage.setItem('refreshToken', refreshToken);
      state.refreshToken = refreshToken;

      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    },
    setUser(state, user) {
      state.user = user;
    },
    logout(state) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');

      state.accessToken = null;
      state.refreshToken = null;
      state.user = null;

      axios.defaults.headers.common.Authorization = null;
    },
  },
  actions: {
    init({ state }) {
      if (state.accessToken != null) {
        axios.defaults.headers.common.Authorization = `Bearer ${state.accessToken}`;
      }
    },
    load({ commit, dispatch }) {
      dispatch('init');

      return new Promise((resolve, reject) => {
        AuthService.getUser()
          .then((user) => {
            commit('setUser', user);

            return resolve();
          }).catch(reject);
      });
    },
    login({ commit, dispatch }, { username, password }) {
      return new Promise((resolve, reject) => {
        AuthService.authenticate(username, password)
          .then(({ accessToken, refreshToken }) => {
            commit('setTokens', {
              accessToken,
              refreshToken,
            });
          })
          .then(() => dispatch('load'))
          .then(resolve)
          .catch(reject);
      });
    },
    logout({ commit }) {
      commit('logout');
    },
    refreshToken({ commit, state }) {
      return new Promise((resolve, reject) => AuthService.refreshToken(state.refreshToken)
        .then(({ accessToken, refreshToken }) => {
          commit('setTokens', {
            accessToken,
            refreshToken,
          });

          resolve(accessToken);
        }).catch(reject));
    },
  },
};
